var _MainCategoriesConten, _MainCategoriesConten2;
import { cx } from 'class-variance-authority';
import { MainCategoriesContentSkeleton } from "./MainCategoriesContentSkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MainCategoriesCoursesViewSkeleton = function MainCategoriesCoursesViewSkeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('tw-pl-2 tw-pt-2', className),
    "data-testid": "main-categories-courses-view-skeleton",
    children: [_MainCategoriesConten || (_MainCategoriesConten = /*#__PURE__*/_jsx(MainCategoriesContentSkeleton, {
      className: "tw-mb-2"
    })), _MainCategoriesConten2 || (_MainCategoriesConten2 = /*#__PURE__*/_jsx(MainCategoriesContentSkeleton, {
      className: "tw-mb-2"
    }))]
  });
};